// extracted by mini-css-extract-plugin
export var menuItem = "o2VlC";